export class CorrectionDeadlineExceeded {
  constructor(public readonly correctionDeadline: Date) {}
}
